export function OutlineBrainIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0013 16.9978C10.3454 16.9978 9.00146 15.6539 9.00146 13.9979C9.00146 12.342 10.3454 10.998 12.0013 10.998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0012 16.998C13.1052 16.998 14.0027 17.8956 14.0027 18.9996V21.0011"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7803 11.8711C21.3994 13.407 20.6603 15.1542 19.1243 15.7781C17.5884 16.4021 15.8413 15.6581 15.2173 14.1222"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99824 13.9984C5.79033 13.9984 4 12.2081 4 10.0002C4 7.79228 5.79033 6.00195 7.99824 6.00195"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24301 8.36749C7.48944 6.29398 8.5598 3.99487 10.6333 3.2413C12.7068 2.48773 15.0059 3.55809 15.7595 5.6316"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7642 5.67866C17.5977 4.44511 20.0792 4.92989 21.3175 6.75862C22.4167 8.39535 22.1527 10.5505 20.78 11.8704"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9307 8.85663C15.8986 8.77983 17.5977 10.1334 18.0009 11.9957"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
